import React from 'react';
import { RocheUIIcon } from '@repo/roche-ui';

const getItemsWithEllipsis =
  (count, ellipsis = '…') =>
  (page, total) => {
    const { floor, min, max } = Math;
    const range = (lo, hi) => Array.from({ length: hi - lo }, (_, i) => i + lo);
    const start = max(1, min(page - floor((count - 3) / 2), total - count + 2));
    const end = min(total, max(page + floor((count - 2) / 2), count - 1));
    return [
      ...(start > 2 ? [1, ellipsis] : start > 1 ? [1] : []),
      ...range(start, end + 1),
      ...(end < total - 1 ? [ellipsis, total] : end < total ? [total] : []),
    ];
  };

export const Pagination = ({
  pageCount,
  activePage,
  onClick,
  onMouseEnter,
  onFocus,
  resultsPerPageCount,
}: {
  pageCount: number;
  activePage: number;
  onClick: (page: number) => void;
  onMouseEnter: (page: number) => void;
  onFocus: (page: number) => void;
  resultsPerPageCount: number;
}) => {
  const previousPage = Math.max(activePage - 1, 1);
  const previousButtonProps = activePage === 1 ? { disabled: true } : {};
  const nextPage = Math.min(activePage + 1, pageCount);
  const nextButtonProps = activePage === pageCount ? { disabled: true } : {};
  const ellipsis = '…';

  return (
    <roche-pagination-container data-rpp={resultsPerPageCount}>
      <roche-pagination-button
        onClick={() => onClick(previousPage)}
        onMouseEnter={() => onMouseEnter(previousPage)}
        onFocus={() => onFocus(previousPage)}
        key={'pagination-arrow-left'}
        {...previousButtonProps}
      >
        <RocheUIIcon icon='chevron-left' width='24px' decorative />
      </roche-pagination-button>
      {getItemsWithEllipsis(7, ellipsis)(activePage, pageCount).map((item, index) => {
        const buttonProps: { active?: boolean } = {};

        if (item === activePage) {
          buttonProps.active = true;
        }

        return item === ellipsis ? (
          <span key={`pagination-ellipsis-${index}`}>{ellipsis}</span>
        ) : (
          <roche-pagination-button
            onClick={() => onClick(item)}
            onMouseEnter={() => onMouseEnter(item)}
            onFocus={() => onFocus(item)}
            key={`pagination-${item}`}
            {...buttonProps}
          >
            {item}
          </roche-pagination-button>
        );
      })}
      <roche-pagination-button
        onClick={() => onClick(nextPage)}
        onMouseEnter={() => onMouseEnter(nextPage)}
        onFocus={() => onFocus(nextPage)}
        key={'pagination-arrow-right'}
        {...nextButtonProps}
      >
        <RocheUIIcon icon='chevron-right' width='24px' decorative />
      </roche-pagination-button>
    </roche-pagination-container>
  );
};
